const breakpointS = 760;

export { breakpointS };
